import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import CardsBody from './CardsBody';
import CardsData from './CardsData';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected, intl } = props;

  return (
    <>
      <CardsBody data={data} id={block} intl={intl} isEditMode />
      <SidebarPortal selected={selected}>
        <CardsData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  // data: PropTypes.shape({
  //   size: PropTypes.string,
  //   spacing: PropTypes.string,
  // }),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
